import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

interface Props {
  onClearFilters: () => void
}

export function SensemakerListEmptyState({ onClearFilters }: Props) {
  return (
    <Box
      data-testid="sensemaker-list-empty-state"
      sx={{
        py: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography sx={{ color: 'text.secondary', fontSize: '16px' }}>
        No Sensemakers match this filter.
      </Typography>
      <Button
        variant="outlined"
        onClick={onClearFilters}
        data-testid="sensemaker-list-clear-filters"
      >
        Clear Filters
      </Button>
    </Box>
  )
}
